import Vue from 'vue'
import VueRouter from "vue-router";

// 引入组件
import downloadPage from "@/page/Download.vue";
import downloadPageV3 from "@/page/DownloadV3.vue";
import getApp from "@/page/GetApp.vue";

// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [
    {
        path:"/",
        component: downloadPage
    },
    {
        path:"/v3",
        component: downloadPageV3
    },
    {
        path:"/getapp",
        component: getApp
    },
	{path:'*',redirect:'/'} //这个路由的目的是如果在用户输入的路由在上面的路由都没有找到，就默认跳到根目录下
]

var router =  new VueRouter({
    routes:routes //,
	//mode:"history" //去掉#
})
export default router;